module.exports = __webpack_public_path__ + "static/media/YM77_0.d7806ec2.jpg";